import { HttpInterceptorFn } from '@angular/common/http';

export const RemoveTrailingSlashInterceptor: HttpInterceptorFn = (
  req,
  next
) => {
  const urlWithoutTrailingSlash = req.url.replace(/\/+$/, '');
  const modifiedRequest = req.clone({
    url: urlWithoutTrailingSlash,
  });
  return next(modifiedRequest);
};
